import { c as _c } from "react/compiler-runtime";
import { UiSelector } from "@/utils/uiSelectors";
export function InfoDescription() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p data-testid={UiSelector.LederInfoDescription}>Personen som er oppgitt som nærmeste leder får tilgang til den sykmeldte ansatte og oppfølgingstjenestene på "Dine sykmeldte" på Nav sine innloggede sider.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}